// Test IDs for the "Знаки и смыслы | бабушка Варвара" landing page.
// Naming follows the directive in ./auth.js (keys camelCase, values kebab-case).

export const LANDING = {
  headerLogo: 'header-logo',
  headerChatCta: 'header-chat-cta-btn',
  headerLoginLink: 'header-login-link',
  headerChannelLink: 'header-channel-link',
  headerTelegramChannelLink: 'header-telegram-channel-link',

  heroPrimaryCta: 'hero-primary-cta-btn',
  heroSecondaryCta: 'hero-secondary-cta-btn',
  heroDisclaimer: 'hero-disclaimer-text',
  heroImage: 'hero-babushka-image',

  weeklyRhythmPrefix: 'weekly-rhythm-',
  bublikImage: 'bublik-image',
  bublikCta: 'bublik-cta-btn',

  analyzeCardName: 'analyze-card-name',
  analyzeCardBirthdate: 'analyze-card-birthdate',
  analyzeCardTarot: 'analyze-card-tarot',
  analyzeCardPalm: 'analyze-card-palm',
  analyzeCardCompat: 'analyze-card-compatibility',
  analyzeCta: 'analyze-cta-btn',

  pricingCardCtaPrefix: 'pricing-card-cta-',

  stepOne: 'how-it-works-step-1',
  stepTwo: 'how-it-works-step-2',
  stepThree: 'how-it-works-step-3',
  stepFour: 'how-it-works-step-4',

  pricingCardPrefix: 'pricing-card-',
  pricingFreeNote: 'pricing-free-note',

  safetyItemPrefix: 'safety-item-',

  faqAccordion: 'faq-accordion',
  faqItemPrefix: 'faq-item-',

  finalCta: 'final-cta-btn',
  finalCtaTelegram: 'final-cta-telegram-btn',
  finalCtaMaxChannel: 'final-cta-max-channel-btn',
  finalCtaTelegramChannel: 'final-cta-telegram-channel-btn',

  footerDisclaimer: 'footer-disclaimer-text',
  footerChannelLink: 'footer-channel-link',
  footerBotLink: 'footer-bot-link',
  footerTelegramBotLink: 'footer-telegram-bot-link',
  footerTelegramChannelLink: 'footer-telegram-channel-link',

  stickyMobileCta: 'sticky-mobile-cta-btn',
};
